import React from 'react';
import { defineCommand } from '../../../../../concepts/commands/CommandDefinition';
import { ObjectManager } from '../../../../../concepts/objects';
import { select } from '../../../../canvas/commands/SelectionCommands';
import { Phys } from '../../../../canvas/entities/Phys';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { FlexLayout } from '../../../autoLayout/FlexLayout';
import { Sticky } from '../../../paper/Sticky';
import { createSticky } from '../../../paper/StickyCommands';
import { useAssitantToolCallResult } from '../../AssistantHooks';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const AddStickiesToolCallView = React.memo(({ toolCallId }: ToolCallPart) => {

    const result = useAssitantToolCallResult(toolCallId) as any;

    return <Flexer padding=".5">
        <Copy flush>
            {result?.message ?? 'Working...'}
        </Copy>
    </Flexer>;
});

export const AddStickiesToolSupport = AssitantToolSupport({
    toolName: 'addStickies',
    ui: AddStickiesToolCallView,
    command: defineCommand(
        'assitantAddStickies',
        null,
        (cc, [args]: [any]) => {

            const { items } = args;
            const objects = cc.resolve(ObjectManager);

            objects.update(() => {
                const ids = items.map(tm => cc.dispatch(createSticky, [tm]));
                const stickies = ids.map(id => objects.get(id, Sticky));
                const bounds = Phys.from(stickies)
                    .bounds()
                    .inflate((Math.sqrt(stickies.length) * 180) / 2);
                FlexLayout.exec(bounds, ['row', 'center', 'center', 10], stickies);
                cc.dispatch(select, [stickies.map(x => x.id)]);
            });

            return { ok: true, message: `Added ${items.length} stickies to the board.` };
        }
    )
});
